import { Tooltip } from '@mantine/core';
import { Icon, variants } from '@uag/react-core';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/react/shallow';

import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';
import { PlacementState } from 'app/modules/wallforming/components/state-management/placement/types';
import { PRIMARY_COLOR_ACCENT_HEX } from 'shared/constants';

export const ArticlesCountInfo = () => {
    const { t } = useTranslation();

    const selectAllInstances = (state: PlacementState) =>
        Object.values(state.articles).reduce((sum, article) => sum + Object.keys(article.articleInstances).length, 0);

    const articlesCount = usePlacementStore(useShallow((state) => selectAllInstances(state)));

    return (
        <Tooltip label={t('labelArticlesCount')} position="bottom" variant={variants.tooltip.bottom}>
            <div className="flex items-center justify-between w-full h-full">
                <Icon className="icon-medium" color={PRIMARY_COLOR_ACCENT_HEX} icon="deployed_code" />
                <div className="text-xs leading-none tabular-nums text-right w-7">{articlesCount.toString()}</div>
            </div>
        </Tooltip>
    );
};
